import type { CSSProperties } from 'react'

export const titleStyle: CSSProperties = {
  fontSize: 18
}

export const conversionTitleStyle: CSSProperties = {
  fontSize: 14,
  paddingBottom: 10
}

export const rowCenterGap3Style: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 3
}

export const rowCenterGap5Font14Style: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 5,
  fontSize: 14
}

export const rowCenterGap5Style: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 5
}

export const icon18Style: CSSProperties = {
  height: 18,
  width: 18
}

export const externalLinkTextStyle: CSSProperties = {
  textDecoration: 'underline',
  display: 'flex',
  alignItems: 'center'
}
